import { Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import MultiTrayVariantSection from './MultiTrayVariantSection';
import SingleTrayVariantSection from './SingleTrayVariantSection';

let SievingWashWashingSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const singleTray = useSelector(
    pipe(createWorksheetSelector!('Masses.MeasuredWashedConstantDryMass.DryingTrays'), (p) => !p || p.length < 2)
  );

  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} name="Masses.InitialDryMass" />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="oven"
          name="Masses.MeasuredWashedConstantDryMass.Equipment.Oven"
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          name="Equipment.WashingSieve"
          queryParams={{ SieveSize: '63 μm' }}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          name="Equipment.GuardSieve"
          queryParams={{ SieveSize: '1.00 mm:4.75 mm' }}
        />
      </ListFieldSection>

      <NamePrefixModifier appendNamePrefix={'Masses.MeasuredWashedConstantDryMass'}>
        {singleTray ? <SingleTrayVariantSection /> : <MultiTrayVariantSection />}
      </NamePrefixModifier>
    </>
  );
};

SievingWashWashingSection = withInjectedProps(SievingWashWashingSection);

export default SievingWashWashingSection;
export { SievingWashWashingSection as WashingSection };
